"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partnerContractsFiles = exports.partnerContracts = void 0;
var qs = require('qs');
var PartnerContractsUrl = '/contracts';
var PartnerContractFilesUrl = '/contract-files/contract';
exports.partnerContracts = function (axios) {
    return {
        getContracts: function (GetContractsRequest) {
            return axios.get(PartnerContractsUrl, GetContractsRequest);
        },
        putContracts: function (PutContractsRequest) {
            return axios.put(PartnerContractsUrl, PutContractsRequest.data);
        }
    };
};
exports.partnerContractsFiles = function (axios) {
    return {
        getContractsFiles: function (GetContractFilesRequest) {
            return axios.get(PartnerContractFilesUrl, GetContractFilesRequest);
        },
        putContractsFiles: function (putContractFilesRequest) {
            var query = qs.stringify(putContractFilesRequest.params);
            return axios.put(PartnerContractFilesUrl + "?" + query, putContractFilesRequest.data);
        },
    };
};
